// extracted by mini-css-extract-plugin
export default {"data-hook-wrapper":"_2EfV7","dataHookWrapper":"_2EfV7","core-badge":"_1a7_D","coreBadge":"_1a7_D"};